import GAAnalytics from '../GAAnalytics';
import MOAnalytics from '../MOAnalytics';

const initialize = (trackingIdUA, trackingIdGA4) => {
  GAAnalytics.initialize(trackingIdUA, trackingIdGA4);
  MOAnalytics.initialize();
};

const set = fieldsObject => {
  GAAnalytics.set(fieldsObject);
};
const setDimension = ({ key, value }) => {
  GAAnalytics.setDimension({ key: key, value: value });
};

const setUserId = userId => {
  GAAnalytics.setUserId(userId);
  MOAnalytics.setUserId(userId);
};

const registerProperties = propertyObject => {
  GAAnalytics.registerProperties(propertyObject);
  MOAnalytics.registerProperties(propertyObject);
};

const setLogCampaignDetails = propertyObject => {
  GAAnalytics.setLogCampaignDetails(propertyObject);
};

const unregisterProperties = () => {
  GAAnalytics.unregisterProperties();
  MOAnalytics.logout();
};

// @otherParams is a object of key:value pair
const pageview = async ({ path = '', title = '', location = '', otherParams = {} }) => {
  GAAnalytics.pageview({ path, title, location, otherParams });
};

// @otherParams is a object of key:value pair
const event = async ({ category = '', action, otherParams = {} }) => {
  await GAAnalytics.event({ category, action, otherParams });
};

const logMoengageEvent = (event, params) => {
  MOAnalytics.logEvent(event, params);
};

// @otherParams is a object of  key:value pair
const timings = ({ category = '', otherParams = {} }) => {
  GAAnalytics.timings({ category, otherParams });
};

const exception = ({ message = '', fatal = false }) => {
  GAAnalytics.exception({ message, fatal });
};

const logout = () => {
  MOAnalytics.logout();
};

export default {
  initialize,
  set,
  setDimension,
  setUserId,
  registerProperties,
  pageview,
  event,
  exception,
  timings,
  logMoengageEvent,
  logout,
  unregisterProperties,
  setLogCampaignDetails
};
